import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_24107_1281)\"><path d=\"M19.5936 7.72705C19.9167 6.97938 20.2508 6.23394 20.5998 5.49369C21.1348 4.39776 20.3612 3.25959 18.8259 3.07508C15.7085 2.70829 12.5586 2.70829 9.44195 3.07508C7.90587 3.25959 7.13301 4.39776 7.66727 5.49369C8.01627 6.23394 8.35046 6.97864 8.67354 7.72705C5.49319 9.60028 3.35986 13.0578 3.35986 17.0154C3.35986 22.9649 8.183 25.3494 14.1332 25.3494C20.0834 25.3494 24.9065 22.9656 24.9065 17.0154C24.9065 13.0585 22.7724 9.60028 19.5936 7.72779V7.72705Z\" fill=\"#B1BEFF\"></path><g opacity=\"0.5\"><path d=\"M12.0142 21.2057H12.0016C11.6726 21.2057 11.3866 21.0205 11.2991 20.7026L9.53335 14.2604C9.42517 13.8654 9.65784 13.469 10.0528 13.3608C10.4477 13.2526 10.8553 13.4912 10.9627 13.8854L12.0587 17.9001L13.3495 13.7313C13.4458 13.4216 13.7326 13.2015 14.0571 13.2015H14.1497C14.4854 13.2015 14.7789 13.4364 14.8655 13.7602L15.9763 17.909L17.2538 13.8995C17.3783 13.5097 17.7954 13.2956 18.1845 13.4193C18.5742 13.5438 18.7899 13.961 18.6661 14.3508L16.6217 20.773C16.5217 21.0864 16.2312 21.2961 15.8985 21.2894C15.5695 21.282 15.285 21.0582 15.1997 20.7404L14.0549 16.4693L12.7211 20.7255C12.6248 21.036 12.3373 21.2042 12.0135 21.2042L12.0142 21.2057Z\" fill=\"#5061FA\"></path><path d=\"M19.3217 16.019H8.79959C8.39056 16.019 8.05859 15.687 8.05859 15.278C8.05859 14.869 8.39056 14.537 8.79959 14.537H19.3217C19.7307 14.537 20.0627 14.869 20.0627 15.278C20.0627 15.687 19.7307 16.019 19.3217 16.019Z\" fill=\"#5061FA\"></path></g><path d=\"M13.8121 9.18382C10.1835 9.18382 8.20134 8.26647 8.08278 8.21089C7.71376 8.03454 7.55667 7.59216 7.73303 7.22315C7.90864 6.85487 8.34953 6.69778 8.71855 6.87192C8.77561 6.89785 12.6028 8.61918 19.4237 7.0053C19.8216 6.91193 20.221 7.1572 20.3151 7.55585C20.4092 7.95377 20.1632 8.35317 19.7646 8.44727C17.4534 8.99413 15.4616 9.18382 13.8114 9.18382H13.8121Z\" fill=\"#5061FA\"></path></g><circle cx=\"23\" cy=\"21.5\" r=\"5\" fill=\"#5061FA\"></circle><path d=\"M20.5 21.5H25.5\" stroke=\"white\" stroke-width=\"1.5\" stroke-linecap=\"round\"></path>", 3)
const _hoisted_5 = {
  key: 0,
  d: "M23 19L23 24",
  stroke: "white",
  "stroke-width": "1.5",
  "stroke-linecap": "round"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_24107_1281" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "21.5459",
      height: "22.5485",
      fill: "white",
      transform: "translate(3.35986 2.79999)"
    })
  ])
], -1)


export default /*#__PURE__*/_defineComponent({
  name: 'Money',
  props: {
    size: null,
    type: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size || 40,
    height: __props.size || 40,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _hoisted_2,
    (__props.type !== 'minus')
      ? (_openBlock(), _createElementBlock("path", _hoisted_5))
      : _createCommentVNode("", true),
    _hoisted_6
  ], 8, _hoisted_1))
}
}

})